(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* LINK-GRUPPEN DER FUSSZEILE (Design-Umbau P2): mobil <details>-Zeilen zum
     Aufklappen, ab 750 px immer offen. Das Markup ist zu (mobil zuerst, kein
     Sprung beim Laden). Ab 750 px oeffnet dieses Skript die Gruppen und haelt
     sie offen — ein Klick auf den Kopf klappt dort nichts zu, der Kopf ist
     kein Tabstopp. Browser mit ::details-content zeigen den Inhalt schon per
     CSS (assets/section-footer.css). Wechselt die Breite, folgt der Zustand. */
  (function () {
    var BREIT = '(min-width: 750px)';
    var SEL = 'details[data-ap-fuss-gruppe]';

    function breit() {
      return typeof window.matchMedia === 'function' && window.matchMedia(BREIT).matches;
    }

    /* Nur ECHTE Aenderungen schreiben (Phase D Teil 2, P1 Massnahme 9): jedes gesetzte „open" weckt den
       Zustands-Wachposten (assets/ap-schwebe.js, attributeFilter open am ganzen Dokument), und auch ein Setzen
       auf denselben Wert meldet eine Mutation — beim erneuten Anwenden (Abschnitt neu geladen, Breitenwechsel
       ohne Zustandswechsel) geschah das bisher je Gruppe zweimal ohne Wirkung. */
    function anwenden() {
      var offen = breit();
      document.querySelectorAll(SEL).forEach(function (gruppe) {
        if (gruppe.open !== offen) gruppe.open = offen;
        var kopf = gruppe.querySelector('summary');
        if (!kopf) return;
        if (offen) {
          if (kopf.getAttribute('tabindex') !== '-1') kopf.setAttribute('tabindex', '-1');
        } else if (kopf.hasAttribute('tabindex')) {
          kopf.removeAttribute('tabindex');
        }
      });
    }

    document.addEventListener(
      'click',
      function (event) {
        var ziel = event.target;
        if (!ziel || typeof ziel.closest !== 'function' || !breit()) return;
        var kopf = ziel.closest(SEL + ' > summary');
        if (kopf) event.preventDefault();
      },
      true
    );

    if (typeof window.matchMedia === 'function') {
      var mq = window.matchMedia(BREIT);
      if (typeof mq.addEventListener === 'function') mq.addEventListener('change', anwenden);
    }
    document.addEventListener('shopify:section:load', anwenden);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', anwenden);
    } else {
      anwenden();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // KOPFHOEHE PER RESIZEOBSERVER (Phase D Teil 2, P1 Massnahme 4): setHeaderHeight las offsetHeight beim
      // Einhaengen (erzwungenes Layout, Lighthouse-Reflow bis 165 ms Desktop) und schrieb --header-height an <html>
      // (Stil-Neuberechnung des ganzen Dokuments) — auch ohne Aenderung. Jetzt meldet ein ResizeObserver die Hoehe
      // nach dem Layout (vor dem Malen, im ersten Bild), geschrieben wird nur eine GEAENDERTE Hoehe. Ohne
      // ResizeObserver wie bisher.
      // Gemessen wird wie bisher die Hoehe des NICHT klebenden Kopfes: im Klebezustand blendet ap-header-nav.css das
      // Anrufband aus und der Kasten schrumpft (den Platz haelt der Rand, merkeBandhoehe) — jede Meldung dort waere
      // je Kleben/Loesen eine Mutation an <html> ohne Nutzen. Ein immer klebender Kopf meldet seine Hoehe.
      if ('ResizeObserver' in window) {
        this.hoeheBeob = new ResizeObserver((eintraege) => {
          if (!this.headerIsAlwaysSticky && this.header.classList.contains('shopify-section-header-sticky')) return;
          const e = eintraege[eintraege.length - 1];
          const box = e && e.borderBoxSize ? e.borderBoxSize[0] || e.borderBoxSize : null;
          const h = box && box.blockSize >= 0 ? box.blockSize : this.header.offsetHeight;
          this.hoeheSchreiben(Math.round(h));
        });
        this.hoeheBeob.observe(this.header);
      } else {
        this.setHeaderHeight();
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      this.hoeheSchreiben(this.header.offsetHeight);
    }

    /* Schreibt --header-height an <html> nur, wenn sich die Hoehe aendert (P1 Massnahme 4 und 9: keine
       Mutation an <html> ohne Aenderung). */
    hoeheSchreiben(h) {
      if (!Number.isFinite(h) || h === this.headerHoehe) return;
      this.headerHoehe = h;
      document.documentElement.style.setProperty('--header-height', `${h}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.hoeheBeob) this.hoeheBeob.disconnect();
      this.hoeheBeob = null;
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.merkeBandhoehe();
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.merkeBandhoehe();
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    /* Hoehe des Anrufbands, solange es steht (Pruefrunde 1 Phase C): im Klebezustand ist das Band
       weg, der Rand der Sektion haelt seinen Platz frei (ap-header-nav.css) — so aendert sich die
       Hoehe im Fluss weder beim Kleben noch am Seitenanfang. Gemessen wird nur beim Uebergang in
       den Klebezustand (einmal, nicht je Scroll-Ereignis); ohne Band oder ab 990 px 0 px. */
    merkeBandhoehe() {
      if (this.header.classList.contains('shopify-section-header-sticky')) return;
      const band = this.header.querySelector('.ap-call-bar');
      this.header.style.setProperty('--ap-call-bar-h', `${band ? band.offsetHeight : 0}px`);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    /* NUR OFFENES SCHLIESSEN (Feinschliff 3 FIX, 04.10.2026, gegnerische Pruefung Mobil, major): hide()
       laeuft beim Abwaertswischen in JEDEM Scroll-Bild. close() entfernte dabei jedes Mal 'overflow-hidden'
       vom <body> (DetailsModal.close) und setzte aria-expanded — Mutationen ohne Aenderung, die jeden
       <body>-Beobachter weckten (gemessen 259 Klassen-Mutationen in 13 s, 200x aus closeSearchModal; dahinter
       getComputedStyle/offsetWidth je Bild im Google-Abzeichen). Geschlossenes bleibt jetzt unberuehrt. */
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        const details = disclosure.mainDetailsToggle || disclosure.querySelector('details');
        if (details && !details.hasAttribute('open')) return;
        disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      const details = this.searchModal.detailsContainer || this.searchModal.querySelector('details');
      if (details && !details.hasAttribute('open')) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Anruf-Lasche an die Judge.me-Lasche andocken.

     Judge.me gehoert uns nicht: .jdgm-revs-tab-btn wird von der App-Erweiterung
     asynchron nachgeladen und kann jederzeit umbenannt, verschoben oder
     abgeschaltet werden. Deshalb NIE fest annehmen, dass sie da ist — gefunden
     wird angedockt, nicht gefunden bleibt der CSS-Rueckfall stehen. Der
     Beobachter haengt nur so lange am Dokument, bis er sie einmal hatte
     (danach reicht ResizeObserver), und gibt nach 20 s ohnehin auf.

     KOSTEN (Phase D, DT-1-Nachmessung 29.09.2026): Beobachter und resize rufen
     reposition() NICHT mehr direkt auf, sondern hoechstens einmal je Bild
     (planen -> requestAnimationFrame) und nur, wenn die Nachbarlasche ueberhaupt
     im Dokument steht. Vorher las JEDER Beobachter-Rueckruf getBoundingClientRect
     — eine erzwungene Stil- und Layout-Neuberechnung je DOM-Einfuegung, solange
     die Lasche noch nicht angedockt war (Trace PDP 1440 in der Vorschau: 26 Mal,
     1,8 s; live 3 Mal). */
  /* GEAENDERT Phase D Teil 2 (P1 „skripte", plan.md b1 Massnahme 4, 08.10.2026). Lighthouse M0: reposition()
     erzwang 124 ms (mobil) bzw. 131 ms (Desktop) Reflow im Median, live 50 / 64 — die erste Lesung lief beim
     Einhaengen (die Judge.me-Lasche steht schon im Server-HTML, ihr App-CSS fehlt dann noch), danach weckte der
     Beobachter am GANZEN Dokument (childList, subtree) jede Einfuegung irgendwo auf der Seite. Jetzt:
       - beim Einhaengen keine Lesung, nur planen() (einmal je Bild);
       - beobachtet wird nur die Lasche selbst: ihre Huelle (Attribute, Neu-Rendern) und ihre Groesse
         (ResizeObserver — das App-CSS dreht und verkleinert sie), dazu die direkten Kinder des <body> (eine spaet
         eingesetzte Huelle) und `load` (App-CSS geladen); weiter hoechstens 20 s, bis angedockt ist;
       - spaet geladene Bausteine meldet P5 mit `ap:spaet-geladen` — dann einmal neu andocken (planen);
       - ohne .jdgm-revs-tab-btn (reifen-b2b) kehrt planen() sofort zurueck.
     Angedockt haelt wie bisher der ResizeObserver der Nachbarlasche die Lage nach (reposition nach dem Layout).
     NACHBESSERUNG N1 (M1-d, 10.10.2026): auch EINE Lesung je Bild (getBoundingClientRect der Judge.me-Lasche,
     getComputedStyle(this).bottom und innerHeight im requestAnimationFrame) erzwang beim Laden die Layout-Berechnung
     der ganzen Seite — Lighthouse M1-d 20–152 ms auf allen Seiten (PD-10). Jetzt liest der BROWSER: ein
     IntersectionObserver meldet nach dem naechsten Layout die Kaesten BEIDER Laschen (Erstmeldung je Anmeldung),
     gerechnet wird nur mit der Meldung. Der neue Versatz ist der gemeldete Abstand (Oberkante Judge.me-Lasche minus
     Unterkante dieser Lasche) plus der zur Meldung gehoerende Versatz — dieselbe Zahl wie Ruhelage minus Ziel, ohne
     Stil- und Fensterlesung (transform verschiebt nur senkrecht; `translate` beim Einklappen nur waagerecht).
     Ohne IntersectionObserver wie bisher (reposition liest selbst). */
  class ApCallTab extends HTMLElement {
    connectedCallback() {
      this.reposition = this.reposition.bind(this);
      this.planen = this.planen.bind(this);
      this.gemeldet = this.gemeldet.bind(this);
      // Der zuletzt geschriebene Andock-Versatz (bleibt nach erneutem Einhaengen am Element stehen) — Inline-Stil,
      // keine Layout-Lesung.
      this.dy = parseFloat(this.style.getPropertyValue('--ap-call-tab-dy')) || 0;
      this.planen();

      if (!this.docked) {
        this.lascheBeobachten();
        this.giveUp = setTimeout(() => this.stopWatching(), 20000);
      }

      window.addEventListener('resize', this.planen);
      window.addEventListener('load', this.planen, { once: true });
      document.addEventListener('ap:spaet-geladen', this.planen);
      this.watchCallBar();
    }

    disconnectedCallback() {
      this.stopWatching();
      if (this.sizes) this.sizes.disconnect();
      if (this.barWatch) this.barWatch.disconnect();
      if (this.bild) { cancelAnimationFrame(this.bild); this.bild = 0; }
      if (this.messer) { this.messer.disconnect(); this.messOffen = false; }
      if (this.messUhr) { clearTimeout(this.messUhr); this.messUhr = 0; }
      window.removeEventListener('resize', this.planen);
      window.removeEventListener('load', this.planen);
      document.removeEventListener('ap:spaet-geladen', this.planen);
    }

    /* Die Judge.me-Lasche beobachten, bis angedockt ist: Huelle (Attribute, Kinder), Groesse, und die direkten
       Kinder des <body> fuer eine spaet eingesetzte Huelle. Keine Lesung — jede Meldung ist nur ein planen(). */
    lascheBeobachten() {
      if (this.docked) return;
      if (!this.koerper && document.body) {
        this.koerper = new MutationObserver((liste) => {
          for (const r of liste) {
            for (const n of r.addedNodes) {
              if (n.nodeType !== 1) continue;
              if (n.matches('.jdgm-revs-tab-btn, .jdgm-revs-tab') || n.querySelector('.jdgm-revs-tab-btn')) {
                this.lascheBeobachten();
                this.planen();
                return;
              }
            }
          }
        });
        this.koerper.observe(document.body, { childList: true });
      }
      const lasche = document.querySelector('.jdgm-revs-tab-btn');
      if (!lasche || lasche === this.beobachtet) return;
      this.beobachtet = lasche;
      const huelle = lasche.closest('.jdgm-revs-tab') || lasche.parentElement || lasche;
      if (this.mutations) this.mutations.disconnect();
      this.mutations = new MutationObserver(this.planen);
      this.mutations.observe(huelle, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'position'] });
      if ('ResizeObserver' in window) {
        if (!this.lascheGroesse) this.lascheGroesse = new ResizeObserver(this.planen);
        this.lascheGroesse.observe(lasche);
      }
    }

    planen() {
      if (!document.querySelector('.jdgm-revs-tab-btn')) return;
      if (typeof window.IntersectionObserver !== 'function') {
        // Rueckfall (Stand vor N1): einmal je Bild selbst lesen.
        if (this.bild) return;
        this.bild = requestAnimationFrame(() => {
          this.bild = 0;
          // Ein neu gerenderter Reiter: die Beobachtung zieht mit (ohne Lesung).
          if (!this.docked) this.lascheBeobachten();
          this.reposition();
        });
        return;
      }
      // N1: EINE offene Messung je Meldung (wie bisher ein Bild) — weitere Anlaesse bis zur Meldung zaehlen nicht.
      if (this.messOffen) return;
      this.messOffen = true;
      if (!this.docked) this.lascheBeobachten();
      this.messen();
    }

    /* N1: frische Erstmeldung beider Kaesten anfordern (abmelden, neu anmelden) — kein Lesen hier. */
    messen() {
      const neighbour = document.querySelector('.jdgm-revs-tab-btn');
      if (!neighbour) {
        this.messOffen = false;
        return;
      }
      if (!this.messer) this.messer = new IntersectionObserver(this.gemeldet);
      this.messer.disconnect();
      this.messNb = neighbour;
      this.messBox = null;
      this.messIch = null;
      this.messDy = this.dy;
      this.messer.observe(neighbour);
      this.messer.observe(this);
      // Bleibt die Meldung aus (Ziel waehrend der Messung entfernt), nach 1 s neu fragen; nach drei stillen Versuchen
      // einmal wie bisher selbst lesen — nie haengen bleiben.
      if (this.messUhr) clearTimeout(this.messUhr);
      this.messUhr = setTimeout(() => {
        this.messUhr = 0;
        if (!this.messOffen) return;
        this.messer.disconnect();
        this.messOffen = false;
        this.messStill = (this.messStill || 0) + 1;
        if (this.messStill >= 3) {
          this.messStill = 0;
          if (!this.docked) this.lascheBeobachten();
          this.reposition();
          return;
        }
        this.planen();
      }, 1000);
    }

    /* N1: die Meldung des Browsers (nach dem Layout) — nur rechnen und schreiben. */
    gemeldet(eintraege) {
      for (const e of eintraege) {
        if (e.target === this) this.messIch = e.boundingClientRect;
        else if (e.target === this.messNb) this.messBox = e.boundingClientRect;
      }
      if (!this.messBox || !this.messIch) return; // die zweite Erstmeldung folgt
      const neighbour = this.messNb;
      const box = this.messBox;
      const ich = this.messIch;
      this.messer.disconnect();
      this.messOffen = false;
      this.messStill = 0;
      if (this.messUhr) {
        clearTimeout(this.messUhr);
        this.messUhr = 0;
      }
      // Zwischen Anfrage und Meldung neu gerendert bzw. verschoben: neu messen.
      if (!neighbour.isConnected || this.dy !== this.messDy) {
        this.planen();
        return;
      }
      if (!this.nachbarPasst(box)) return;
      // Steht diese Lasche nicht im Layout (display:none, offenes Menue), gibt es keine Lage: nur die Breite.
      const dy = ich.width >= 1 && ich.height >= 1 ? Math.round(this.messDy + box.top - ich.bottom) : null;
      this.andocken(neighbour, box, dy);
    }

    /* Nur an die GEDREHTE, schmale Nachbarlasche mit eigener Lage (Regeln unten in reposition, unveraendert). */
    nachbarPasst(box) {
      if (box.width < 4 || box.height < 4) return false;
      if (box.top < 1) return false;
      if (box.height <= box.width || box.width < 30 || box.width > 64) return false;
      return true;
    }

    /* Die Lasche schliesst die Luecke NACH dem Anrufband — solange das Band
       im Bild ist, bleibt sie weg (data-bar-visible, Regel in ap-header-nav.css).
       Das Band verschwindet auf zwei Wegen: es scrollt aus dem Bild, oder der
       Kopf klebt und blendet es per display:none aus. Beides meldet der
       Beobachter als "nicht im Bild". Kein Band, kein Beobachter: dann darf
       das Attribut die Lasche nicht dauerhaft verstecken. */
    watchCallBar() {
      const bar = document.querySelector('.ap-call-bar');
      if (!bar || !('IntersectionObserver' in window)) {
        this.removeAttribute('data-bar-visible');
        return;
      }
      this.barWatch = new IntersectionObserver((entries) => {
        const latest = entries[entries.length - 1];
        this.toggleAttribute('data-bar-visible', latest.isIntersecting);
      });
      this.barWatch.observe(bar);
    }

    stopWatching() {
      if (this.mutations) { this.mutations.disconnect(); this.mutations = null; }
      if (this.koerper) { this.koerper.disconnect(); this.koerper = null; }
      if (this.lascheGroesse) { this.lascheGroesse.disconnect(); this.lascheGroesse = null; }
      this.beobachtet = null;
      if (this.giveUp) { clearTimeout(this.giveUp); this.giveUp = null; }
    }

    reposition() {
      const neighbour = document.querySelector('.jdgm-revs-tab-btn');
      if (!neighbour) return;

      const box = neighbour.getBoundingClientRect();
      if (box.width < 4 || box.height < 4) return;
      // Noch ohne eigene Lage (Judge.me-CSS nicht geladen, top 0): nicht
      // andocken — sonst sprang die Lasche kurz an den oberen Rand (CLS).
      if (box.top < 1) return;
      // NUR an die GEDREHTE, schmale Nachbarlasche (Art-Director Feinschliff
      // II R2, 28.09.2026). Die Wache top < 1 greift nicht: ap-header-nav.css
      // erzwingt top schon vor dem App-CSS. Ungedreht (84 x 38) bzw. ohne
      // App-CSS (1.440 px breit) wurde ihre Breite zu --ap-call-tab-width —
      // die Lasche spannte kurz ueber die volle Breite und sprang dann an die
      // Kante: CLS 0,2005 je Desktop-Aufruf (Kollektion, PDP, Suche; LIVE
      // 0,003). Gedreht ist sie hoeher als breit und 30–64 px dick.
      if (box.height <= box.width || box.width < 30 || box.width > 64) return;

      // Andocken per transform statt per bottom (Art-Director Feinschliff II
      // R1, 27.09.2026): ein neuer bottom-Wert verschob die Lasche IM LAYOUT —
      // zwei Layout-Shifts zu je 0,012 zwischen 3 und 15 s ohne Eingabe (CLS
      // ueber dem Falz 0,024 statt live 0,011). bottom bleibt die Ruhelage aus
      // dem CSS; der Versatz zur gemessenen Andockstelle steht als
      // --ap-call-tab-dy im transform, und transform zaehlt nicht als Shift.
      const ruhe = parseFloat(window.getComputedStyle(this).bottom);
      const ziel = window.innerHeight - box.top;
      this.andocken(neighbour, box, Number.isFinite(ruhe) ? Math.round(ruhe - ziel) : null);
    }

    /* Schreiben (beide Wege): Versatz (wenn bekannt), Breite, beim ersten Mal angedockt + Groessenbeobachter. */
    andocken(neighbour, box, dy) {
      // Judge.me rendert die Lasche gelegentlich NEU: der Groessenbeobachter
      // hing am alten Knoten — neu beobachten.
      if (this.sizes && this.neighbour && this.neighbour !== neighbour) {
        this.sizes.disconnect();
        this.sizes.observe(neighbour);
      }
      this.neighbour = neighbour;
      if (dy !== null) {
        this.dy = dy;
        this.style.setProperty('--ap-call-tab-dy', `${dy}px`);
      }
      this.style.setProperty('--ap-call-tab-width', `${Math.min(56, Math.max(36, Math.round(box.width)))}px`);

      if (!this.docked) {
        this.docked = true;
        this.setAttribute('data-docked', '');
        this.stopWatching();
        if ('ResizeObserver' in window) {
          // N1: mit IntersectionObserver meldet eine Groessenaenderung nur eine Messung an (planen); ohne liest
          // reposition wie bisher im Rueckruf nach dem Layout.
          this.sizes = new ResizeObserver(typeof window.IntersectionObserver === 'function' ? this.planen : this.reposition);
          this.sizes.observe(neighbour);
        }
      }
    }
  }

  customElements.define('ap-call-tab', ApCallTab);

  /* LASCHEN BEIM ABWAERTSSCROLLEN EINKLAPPEN (Audit 24.09.,
     einstieg-schwebende-laschen-verdecken). Mobil liegen "Anrufen" und
     "Bewertungen" auf den rechten 37 px des Inhalts — gemessen auf der PDP
     27 Textstellen darunter, u. a. der Satzpreis ("434,72 EU|R"). Wer nach
     unten liest, bekommt sie aus dem Weg; wer hochscrollt, bekommt sie
     zurueck — dasselbe Muster wie der Kopf (on-scroll-up).

     Nur die Richtung wird hier bestimmt, als Klasse am body. Was sie bewirkt
     (translate + visibility, NUR unter 750 px — Betreiber-Entscheidung
     26.09.2026: am Schreibtisch stehen beide Laschen immer), steht in
     ap-header-nav.css.
     Die Andockrechnung der Anruf-Lasche bleibt unberuehrt: translate wirkt
     waagerecht, --ap-call-tab-dy (transform) die Hoehe. Die Judge.me-Lasche
     wird dabei nur voruebergehend weggeschoben, nie abgeschaltet
     (Betreiberentscheidung). Schalter: "Laschen beim Scrollen einklappen".

     AM SEITENANFANG UNTER 750 PX EINGEKLAPPT (Vorschau-Runde 1, 25.09.2026).
     Bis dahin standen die Laschen am Seitenanfang immer. Gemessen lag die
     Judge.me-Lasche (x 353-390, y 364-517) dort auf dem Such-Absendeknopf
     (48 % der Lupe), der Hero-Beschreibung der Kollektionen („warme|n"), dem
     404-Erklaersatz, dem Felgen-Kollektionstext und der Kontakt-Zeile — alles
     Inhalt des ersten Bildschirms, den man am Seitenanfang gerade liest. Im
     Startbereich bleiben die Laschen unter 750 px deshalb eingeklappt, auch
     beim Zurueckscrollen dorthin; hochscrollen weiter unten bringt sie wie
     bisher zurueck. Ab 750 px aendert sich nichts: die Einklapp-Regel in
     ap-header-nav.css gilt dort nicht, die Laschen stehen immer (Betreiber-
     Entscheidung 26.09.2026 — das Schwebe-System hatte das Einklappen kurz auf
     alle Breiten ausgedehnt, zurueckgenommen). Beim Laden einmal auswerten,
     sonst stuende die Lasche bis zum ersten Scrollen. */
  (function () {
    const TUCKED = 'ap-tabs-tucked';
    const SOFORT = 'ap-tabs-sofort';
    const STEP = 12; // Scrollweg in px, ab dem eine Richtung zaehlt (kein Zittern)
    const TOP_ZONE = 120; // Startbereich: Laschen stehen (breit) bzw. bleiben eingeklappt (schmal)
    const SCHMAL = '(max-width: 749px)';
    // STARTLESUNG NACH DEM LAYOUT (Phase D Teil 2, P1 Massnahme 4): hier stand `let last = window.scrollY;` — eine
    // Lesung beim Auswerten des Abschnitts-Skripts (vor dem ersten Layout: erzwungene Neuberechnung der ganzen Seite).
    // Der Ausgangswert kommt jetzt aus dem ersten update(), das im ersten Bild NACH dessen Layout laeuft (unten).
    let last = null;
    let queued = false;

    function schmal() {
      return typeof window.matchMedia === 'function' && window.matchMedia(SCHMAL).matches;
    }

    /* IM STARTBEREICH OHNE GLEITEN EINKLAPPEN (Phase D Stufe 0, 05.10.2026). Wer schnell an den Seitenanfang
       wischt, bekam die Laschen dort eingeklappt (Regel unten, unveraendert) — aber per 220-ms-Gleiten: die
       Anruf-Lasche (Oberkante 84 px bei 375 x 667) ragte waehrenddessen bis 76 px in den aufgeklappten Kopf
       (Rekorder Feinschliff 3, 9 Bilder ~150 ms). Jetzt sind sie dort im selben Bild weg (ap-header-nav.css,
       body.ap-tabs-sofort zwei Bilder ohne Transition). WANN eingeklappt wird, bleibt genau wie bisher. */
    function sofort(body) {
      body.classList.add(SOFORT);
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => body.classList.remove(SOFORT));
      });
    }

    function update() {
      queued = false;
      if (!bereit()) return;
      stand(window.scrollY);
    }

    function bereit() {
      const body = document.body;
      if (!body) return false;
      if (!document.querySelector('[data-ap-tuck-tabs]')) {
        body.classList.remove(TUCKED);
        return false;
      }
      return true;
    }

    /* ERSTE AUSWERTUNG OHNE LESUNG (Phase D Teil 2, M1-d Nachbesserung N1, 10.10.2026): auch im ersten
       ResizeObserver-Rueckruf erzwang `window.scrollY` die Layout-Berechnung der ganzen Seite — andere Rueckrufe
       derselben Meldung schreiben davor (z. B. --header-height); Lighthouse M1-d 30–168 ms auf allen Seiten (PD-10).
       Ein frischer Aufruf (Navigationsart „navigate“) ohne Sprungziel steht beim ersten Layout oben: dann gilt y = 0
       ohne Lesung. Neu laden, Zurueck/Vor (gemerkte Lage) und Sprungziele (#…) lesen wie bisher; hat der Besucher
       vor dem ersten Layout schon gescrollt (last gesetzt), gilt sein Scroll-Bild. */
    function frischOben() {
      if (window.location && window.location.hash) return false;
      try {
        const p = window.performance;
        const nav = p && typeof p.getEntriesByType === 'function' ? p.getEntriesByType('navigation')[0] : null;
        return !!nav && nav.type === 'navigate';
      } catch (e) {
        return false;
      }
    }

    function erstesUpdate() {
      if (last !== null) return;
      if (frischOben()) {
        queued = false;
        if (bereit()) stand(0);
        return;
      }
      update();
    }

    function stand(y) {
      const body = document.body;
      if (last === null) last = y;
      if (y <= TOP_ZONE) {
        const ein = schmal();
        if (ein && !body.classList.contains(TUCKED)) sofort(body);
        body.classList.toggle(TUCKED, ein);
        last = y;
        return;
      }
      const delta = y - last;
      if (Math.abs(delta) < STEP) return;
      body.classList.toggle(TUCKED, delta > 0);
      last = y;
    }

    window.addEventListener(
      'scroll',
      () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    // Drehen/Fenstergroesse: im Startbereich folgt der Zustand der Breite.
    window.addEventListener('resize', () => {
      if (window.scrollY <= TOP_ZONE) update();
    });
    // Beim Laden: das erste update() im ersten Bild NACH dessen Layout und VOR dem Malen (ResizeObserver meldet ein
    // frisch beobachtetes Element genau dort) — die Laschen stehen im ersten gemalten Bild schon richtig; bei einem
    // frischen Aufruf ohne Lesung (erstesUpdate, N1). Nach dem Laden (Theme-Editor) sofort wie bisher.
    function nachDemLayout(fn) {
      if (typeof window.ResizeObserver === 'function' && document.documentElement) {
        const beob = new ResizeObserver(() => {
          beob.disconnect();
          fn();
        });
        beob.observe(document.documentElement);
      } else {
        window.requestAnimationFrame(fn);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => nachDemLayout(erstesUpdate), { once: true });
    } else if (document.readyState === 'complete') {
      update();
    } else {
      nachDemLayout(erstesUpdate);
    }
  })();

  /* HANDY-MENUE, EBENE 2: AUFKLAPPBARE GRUPPEN STATT DRITTER SCHUBLADE
     (Audit 24.09., einstieg-mobilmenue-tiefe). Die Gruppen ("Nach Saison",
     "Nach Zoll", ...) sind native <details> in snippets/header-drawer.liquid.

     Dawns MenuDrawer (global.js) haengt seinen Klick-Handler an JEDES
     <summary> in <header-drawer> und behandelt es als Tuer zu einer weiteren
     Schublade: es setzt `submenu-open` an die Elternliste — die Regel
     `.menu-drawer__navigation .submenu-open { visibility: hidden }` blendete
     damit die offene Ebene aus — und legt die Fokusfalle in die Gruppe.
     Deshalb faengt diese Weiche den Klick auf eine Gruppen-Ueberschrift in
     der Capture-Phase ab, BEVOR er das <summary> erreicht. Das native
     Auf-/Zuklappen ist die Standardaktion und laeuft trotzdem (kein
     preventDefault). Alle anderen <summary> — Wurzel und Ebene 1 — gehen
     unveraendert an Dawn: Fokusfalle und Zurueck-Knoepfe bleiben Dawns.

     Escape in einer offenen Gruppe klappt nur die Gruppe zu; Dawn haette
     sonst closeSubmenu() auf die Gruppe angewandt. Am Dokument statt an
     <header-drawer>, damit ein Neu-Rendern der Sektion (Theme-Editor) die
     Weiche nicht verliert. */
  (function () {
    const GROUP = 'details.ap-drawer-group';

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!target || typeof target.closest !== 'function') return;
        const summary = target.closest('summary');
        if (!summary || !summary.parentElement || !summary.parentElement.matches(GROUP)) return;
        if (!summary.closest('header-drawer')) return;
        event.stopPropagation();
      },
      true
    );

    document.addEventListener(
      'keyup',
      (event) => {
        if (!event.code || event.code.toUpperCase() !== 'ESCAPE') return;
        const target = event.target;
        if (!target || typeof target.closest !== 'function') return;
        const group = target.closest(GROUP + '[open]');
        if (!group || !group.closest('header-drawer')) return;
        event.stopPropagation();
        group.open = false;
        const summary = group.querySelector('summary');
        if (summary) summary.focus();
      },
      true
    );

    /* Ausgangszustand beim OEFFNEN der Schublade wiederherstellen. Dawns
       closeMenuDrawer (global.js) nimmt beim Schliessen `open` von JEDEM
       <details> in der Schublade — auch von den Gruppen. Ohne diesen Nachzug
       war „Nach Saison" nur beim allerersten Oeffnen aufgeklappt, danach
       brauchte „Winterreifen" wieder vier statt drei Taps. Wieder geoeffnet
       wird genau, was der Server als Ausgangszustand markiert hat
       (data-ap-open-default, snippets/header-drawer.liquid); was der Kunde
       innerhalb EINER geoeffneten Schublade auf- oder zuklappt, bleibt stehen.
       `toggle` perlt nicht auf — deshalb in der Capture-Phase am Dokument. */
    document.addEventListener(
      'toggle',
      (event) => {
        const root = event.target;
        if (!root || typeof root.matches !== 'function' || !root.open) return;
        if (!root.matches('header-drawer > details')) return;
        root.querySelectorAll(GROUP + '[data-ap-open-default]:not([open])').forEach((group) => {
          group.open = true;
        });
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
